/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractTenantDocumentFile } from './ContractTenantDocumentFile';
import {
    ContractTenantDocumentFileFromJSON,
    ContractTenantDocumentFileFromJSONTyped,
    ContractTenantDocumentFileToJSON,
    ContractTenantDocumentFileToJSONTyped,
} from './ContractTenantDocumentFile';
import type { FileTypeEnum } from './FileTypeEnum';
import {
    FileTypeEnumFromJSON,
    FileTypeEnumFromJSONTyped,
    FileTypeEnumToJSON,
    FileTypeEnumToJSONTyped,
} from './FileTypeEnum';

/**
 * 
 * @export
 * @interface ContractTenantDocument
 */
export interface ContractTenantDocument {
    /**
     * 
     * @type {FileTypeEnum}
     * @memberof ContractTenantDocument
     */
    fileType: FileTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractTenantDocument
     */
    name: string;
    /**
     * Premier fichier fourni (le seul pour un justificatif mono-fichier)
     * @type {string}
     * @memberof ContractTenantDocument
     */
    storedFileId?: string;
    /**
     * Justificatif pouvant être constitué de plusieurs fichiers (ex. deux bilans OU une attestation d'expert-comptable)
     * @type {boolean}
     * @memberof ContractTenantDocument
     */
    allowMultiple: boolean;
    /**
     * Tous les fichiers fournis, dans l'ordre d'ajout
     * @type {Array<ContractTenantDocumentFile>}
     * @memberof ContractTenantDocument
     */
    files: Array<ContractTenantDocumentFile>;
}



/**
 * Check if a given object implements the ContractTenantDocument interface.
 */
export function instanceOfContractTenantDocument(value: object): value is ContractTenantDocument {
    if (!('fileType' in value) || value['fileType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('allowMultiple' in value) || value['allowMultiple'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    return true;
}

export function ContractTenantDocumentFromJSON(json: any): ContractTenantDocument {
    return ContractTenantDocumentFromJSONTyped(json, false);
}

export function ContractTenantDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractTenantDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'fileType': FileTypeEnumFromJSON(json['fileType']),
        'name': json['name'],
        'storedFileId': json['storedFileId'] == null ? undefined : json['storedFileId'],
        'allowMultiple': json['allowMultiple'],
        'files': ((json['files'] as Array<any>).map(ContractTenantDocumentFileFromJSON)),
    };
}

export function ContractTenantDocumentToJSON(json: any): ContractTenantDocument {
    return ContractTenantDocumentToJSONTyped(json, false);
}

export function ContractTenantDocumentToJSONTyped(value?: ContractTenantDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileType': FileTypeEnumToJSON(value['fileType']),
        'name': value['name'],
        'storedFileId': value['storedFileId'],
        'allowMultiple': value['allowMultiple'],
        'files': ((value['files'] as Array<any>).map(ContractTenantDocumentFileToJSON)),
    };
}

